import React from "react";
import { PopupWidget } from "react-calendly";

const Meeting = () => {
  return (
    <div className="Meeting">
      <PopupWidget className="project-card"
        url="https://calendly.com/d/4sn-w3w-xq7/initial-consultation-call"
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure the modal is inserted into the correct domNode.
         */
        rootElement={document.getElementById("root")}
        text="Book A Meeting!"
        textColor="#ffffff"
        color="#934cce5e"
        id="like-btn"
        
      />
      {/* <!-- Calendly badge widget begin -->
<link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet">
<script src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>
<script type="text/javascript">window.onload = function() { Calendly.initBadgeWidget({ url: 'https://calendly.com/d/4sn-w3w-xq7/initial-consultation-call', text: 'Schedule time with us', color: '#0069ff', textColor: '#ffffff', branding: undefined }); }</script>
<!-- Calendly badge widget end --></link> */}
    </div>
  );
};

export default Meeting;